var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from "styled-components";
var getColor = function (theme, value) {
    var utility = theme.colors.utility;
    switch (value) {
        case "contrast":
            return utility.contrast;
        case "subdued":
            return utility.subdued;
        case "ink":
            return utility.ink;
        case "white":
            return utility.white;
        default:
            return value;
    }
};
var getFontWeight = function (theme, value) {
    var font = theme.font;
    switch (value) {
        case "light":
            return font.light;
        case "bold":
            return font.bold;
        case "semibold":
            return font.semibold;
        default:
            return font.default;
    }
};
export var commonCSS = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (_a) {
    var wordBreak = _a.wordBreak;
    return wordBreak && "word-break: " + wordBreak + ";";
}, function (_a) {
    var overflow = _a.overflow;
    return overflow && "overflow: " + overflow + ";";
}, function (_a) {
    var overflowWrap = _a.overflowWrap;
    return overflowWrap && "overflow-wrap: " + overflowWrap + ";";
}, function (_a) {
    var textDecoration = _a.textDecoration;
    return textDecoration && "text-decoration: " + textDecoration + ";";
}, function (_a) {
    var textAlign = _a.textAlign;
    return textAlign && "text-align: " + textAlign + ";";
}, function (_a) {
    var weight = _a.weight, theme = _a.theme;
    return weight && "font-family: " + getFontWeight(theme, weight) + ";";
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color && "color: " + getColor(theme, color) + ";";
}, function (_a) {
    var display = _a.display;
    return display && "display: " + display + ";";
});
var templateObject_1;
